import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UnsavedChangesModal } from '../AppModal/modals';

function useBlockNavigation(shouldBlock, message, onConfirm) {
  const navigate = useNavigate();
  const [nextLocation, setNextLocation] = useState(null);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (shouldBlock && !confirmed) {
        e.preventDefault();
        e.returnValue = message || 'You have unsaved changes. Are you sure you want to leave?';
      }
    };

    const handlePopState = (e) => {
      if (shouldBlock && !confirmed) {
        e.preventDefault();
        setNextLocation(window.location.pathname);

        // Show unsaved changes modal
        // UnsavedChangesModal(() => {
        //   setConfirmed(true);
        //   if (onConfirm) {
        //     onConfirm();
        //   }
        // });
        const confirmWindow = window.confirm(
          message || 'You have unsaved changes. Are you sure you want to leave?'
        );
        if (confirmWindow) {
          setConfirmed(true);
          if (onConfirm) {
            onConfirm();
          }
          navigate(nextLocation || -1, { replace: true });
        } else {
          e.preventDefault();
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [shouldBlock, confirmed, message, onConfirm, navigate, nextLocation]);

  const blockNavigation = (targetPath) => {
    if (shouldBlock && !confirmed) {
      UnsavedChangesModal(() => {
        setConfirmed(true);
        if (onConfirm) {
          onConfirm();
        }
        navigate(targetPath || -1, { replace: true });
      });
      return false; // Block navigation
    }
    return true; // Allow navigation
  };

  return { blockNavigation, nextLocation, confirmed, setConfirmed };
}

export default useBlockNavigation;
